/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContactInteractionDirection;
(function (ContactInteractionDirection) {
    ContactInteractionDirection["BUSINESS_TO_CUSTOMER"] = "BUSINESS_TO_CUSTOMER";
    ContactInteractionDirection["CUSTOMER_TO_BUSINESS"] = "CUSTOMER_TO_BUSINESS";
})(ContactInteractionDirection = exports.ContactInteractionDirection || (exports.ContactInteractionDirection = {}));
var ContactsOrderDirection;
(function (ContactsOrderDirection) {
    ContactsOrderDirection["ascending"] = "ascending";
    ContactsOrderDirection["descending"] = "descending";
})(ContactsOrderDirection = exports.ContactsOrderDirection || (exports.ContactsOrderDirection = {}));
var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["Text"] = "Text";
    CustomFieldType["Number"] = "Number";
    CustomFieldType["Date"] = "Date";
    CustomFieldType["URL"] = "URL";
})(CustomFieldType = exports.CustomFieldType || (exports.CustomFieldType = {}));
var DataAvailability;
(function (DataAvailability) {
    DataAvailability["COMPLETE"] = "COMPLETE";
    DataAvailability["RESTRICTED"] = "RESTRICTED";
})(DataAvailability = exports.DataAvailability || (exports.DataAvailability = {}));
var DataType;
(function (DataType) {
    DataType["UNKNOWN_DATA_TYPE"] = "UNKNOWN_DATA_TYPE";
    DataType["Text"] = "Text";
    DataType["Number"] = "Number";
    DataType["Date"] = "Date";
    DataType["TextArray"] = "TextArray";
    DataType["ObjectArray"] = "ObjectArray";
    DataType["URL"] = "URL";
})(DataType = exports.DataType || (exports.DataType = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["unknown"] = "unknown";
    DeliveryStatus["valid"] = "valid";
    DeliveryStatus["invalid"] = "invalid";
    DeliveryStatus["bounce"] = "bounce";
    DeliveryStatus["deferral"] = "deferral";
    DeliveryStatus["rejected"] = "rejected";
    DeliveryStatus["spam"] = "spam";
    DeliveryStatus["complaint"] = "complaint";
    DeliveryStatus["inactive"] = "inactive";
})(DeliveryStatus = exports.DeliveryStatus || (exports.DeliveryStatus = {}));
var DomainLabelType;
(function (DomainLabelType) {
    DomainLabelType["userDefined"] = "userDefined";
    DomainLabelType["fromActivity"] = "fromActivity";
    DomainLabelType["fromImport"] = "fromImport";
    DomainLabelType["googleImport"] = "googleImport";
    DomainLabelType["fileImport"] = "fileImport";
})(DomainLabelType = exports.DomainLabelType || (exports.DomainLabelType = {}));
var EmailStatus2;
(function (EmailStatus2) {
    EmailStatus2["transactional"] = "transactional";
    EmailStatus2["recurring"] = "recurring";
    EmailStatus2["optOut"] = "optOut";
})(EmailStatus2 = exports.EmailStatus2 || (exports.EmailStatus2 = {}));
var EmailSubscriptionPolicy;
(function (EmailSubscriptionPolicy) {
    EmailSubscriptionPolicy["RECURRING"] = "RECURRING";
})(EmailSubscriptionPolicy = exports.EmailSubscriptionPolicy || (exports.EmailSubscriptionPolicy = {}));
var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    FieldType["BUILT_IN"] = "BUILT_IN";
    FieldType["USER_DEFINED"] = "USER_DEFINED";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["equals"] = "equals";
    FilterOperator["notEquals"] = "notEquals";
    FilterOperator["startsWith"] = "startsWith";
    FilterOperator["endsWith"] = "endsWith";
    FilterOperator["contains"] = "contains";
    FilterOperator["notContains"] = "notContains";
    FilterOperator["moreOrEquals"] = "moreOrEquals";
    FilterOperator["lessOrEquals"] = "lessOrEquals";
    FilterOperator["in"] = "in";
    FilterOperator["notIn"] = "notIn";
    FilterOperator["between"] = "between";
    FilterOperator["last7Days"] = "last7Days";
    FilterOperator["last30Days"] = "last30Days";
    FilterOperator["last90Days"] = "last90Days";
    FilterOperator["onOrBefore"] = "onOrBefore";
    FilterOperator["onOrAfter"] = "onOrAfter";
    FilterOperator["isTrue"] = "isTrue";
    FilterOperator["isFalse"] = "isFalse";
    FilterOperator["isNotSet"] = "isNotSet";
    FilterOperator["isEmpty"] = "isEmpty";
    FilterOperator["notEmpty"] = "notEmpty";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
var LabelType;
(function (LabelType) {
    LabelType["UNKNOWN_LABEL_TYPE"] = "UNKNOWN_LABEL_TYPE";
    LabelType["SYSTEM"] = "SYSTEM";
    LabelType["USER"] = "USER";
})(LabelType = exports.LabelType || (exports.LabelType = {}));
var MigrationStatus;
(function (MigrationStatus) {
    MigrationStatus["Success"] = "Success";
    MigrationStatus["Locked"] = "Locked";
    MigrationStatus["Failed"] = "Failed";
})(MigrationStatus = exports.MigrationStatus || (exports.MigrationStatus = {}));
var PhotoUrlType;
(function (PhotoUrlType) {
    PhotoUrlType["wixStatics"] = "wixStatics";
    PhotoUrlType["fullUrl"] = "fullUrl";
})(PhotoUrlType = exports.PhotoUrlType || (exports.PhotoUrlType = {}));
var SearchField;
(function (SearchField) {
    SearchField["name"] = "name";
    SearchField["picture"] = "picture";
    SearchField["tags"] = "tags";
    SearchField["company"] = "company";
    SearchField["notes"] = "notes";
    SearchField["emails"] = "emails";
    SearchField["phones"] = "phones";
    SearchField["addresses"] = "addresses";
    SearchField["dates"] = "dates";
    SearchField["urls"] = "urls";
    SearchField["custom"] = "custom";
    SearchField["links"] = "links";
})(SearchField = exports.SearchField || (exports.SearchField = {}));
var SiteMemberStatus;
(function (SiteMemberStatus) {
    SiteMemberStatus["APPLICANT"] = "APPLICANT";
    SiteMemberStatus["ACTIVE"] = "ACTIVE";
    SiteMemberStatus["INACTIVE"] = "INACTIVE";
    SiteMemberStatus["DENIED"] = "DENIED";
    SiteMemberStatus["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(SiteMemberStatus = exports.SiteMemberStatus || (exports.SiteMemberStatus = {}));
